import Button from '../../../components/Button';
import { DeprecatedButtonContainer } from '../../../components/ButtonContainer';
import Modal from '../../../components/Modal';
import { goToUrl } from '../../../services/Router';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export default function UserLoggedOutModal(props: Props) {
    const modalProps = {
        onClose: props.onClose,
        isOpen: props.isOpen,
        title: 'Please log in again',
        size: 'SM_WIDTH' as const,
    };
    const goToLoginPage = () => {
        // Redirect to app home, or to current page if we know it!
        if (window.location.pathname.indexOf('wicket:interface=') !== -1) {
            goToUrl('/app/home');
        } else {
            window.location.reload();
        }
    };
    return (
        <Modal {...modalProps}>
            You’ve been logged out. Please make a copy of unsaved content before you leave this page or log in again.
            <DeprecatedButtonContainer>
                <Button onClick={() => props.onClose()}>Close to copy content</Button>
                <Button kind="PRIMARY" onClick={goToLoginPage}>
                    Go to login page
                </Button>
            </DeprecatedButtonContainer>
        </Modal>
    );
}
